import {filterNotesAsync, getNotesAsync} from "./noteSlice";
import {Row, Col, Table, Button} from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import {useNavigate} from "react-router-dom";
import styles from './Notes.module.css';
import useState from 'react-usestateref'
import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {setActiveLink} from "../navmenu/navbarSlice";
import {connect} from "react-redux";
import {apiRequest, loginRequest} from "../../authConfig";
import {useMsal} from "@azure/msal-react";
import {NoteListRow} from "./NoteListRow";
import {Filters} from "./Filters";
import {YaPagination} from "../../components/YaPagination/YaPagination";
import {YaPaginationSize} from "../../components/YaPagination/YaPaginationSize";
// https://stackoverflow.com/questions/59383595/how-to-debounce-a-controlled-input

export const Notes = () => {

    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const notes = useAppSelector(state => state.note.notes);
    const totalNotes = useAppSelector(state => state.note.totalNotes);

    const [filterQuery, setFilterQuery] = useState<string | undefined>(undefined);
    const [_, setPageSize, pageSizeRef] = useState<number>(0);
    const [showNumberOfPagesMax, setShowNumberOfPagesMax] = useState<number>(0);
    const [tempPageSize, setTempPageSize] = useState<number>(0);
    const [activePage, setActivePage, activePageRef] = useState<number>(1);

    useEffect(() => {
        if (pageSizeRef.current === 0) {
            setPageSize(getPageSize());
            setTempPageSize(getPageSize());
        }
    }, []);

    useEffect(() => {
        dispatch(setActiveLink('/notes'));
        setShowNumberOfPagesMax(getMaxNumberOfPages());
        getNotes();
    }, [dispatch]);

    const getNotes = () => {
        requestApiAccessToken().then(apiToken => {
            dispatch(getNotesAsync({
                apiToken: apiToken,
                activePage: 1,
                pageSize: pageSizeRef.current
            }));
            setTempPageSize(pageSizeRef.current);
        });
    };
    
    const updatePageSize = (pageSize: number) => {
        setPageSize(pageSize);
    }


    const changePage = ((targetPage: number) => {
        setActivePage(targetPage);
        requestApiAccessToken().then(apiToken => {
            if (filterQuery === undefined) {
                dispatch(getNotesAsync({
                    apiToken: apiToken,
                    activePage: targetPage,
                    pageSize: tempPageSize
                }));
            } else {
                dispatch(filterNotesAsync({
                    apiToken: apiToken,
                    filter: filterQuery,
                    activePage: targetPage,
                    pageSize: tempPageSize
                }));
            }
        });
    });

    const getPageSize = () => {
        return process.env.REACT_APP_PAGE_SIZE == undefined ? 0 : parseInt(process.env.REACT_APP_PAGE_SIZE);
    }

    const getMaxNumberOfPages = () => {
        return process.env.REACT_APP_SHOW_MAX_NUMBER_OF_PAGES == undefined ? 0 : parseInt(process.env.REACT_APP_SHOW_MAX_NUMBER_OF_PAGES);
    }
    
    const getMaxPageSize = () => {
        return process.env.REACT_APP_MAX_PAGE_SIZE == undefined ? 0 : parseInt(process.env.REACT_APP_MAX_PAGE_SIZE);
    }

    const handleFilterNotes = async (filter: string) => {
        setTempPageSize(pageSizeRef.current);

        setFilterQuery(filter);
        setActivePage(1);
        const apiToken = await requestApiAccessToken();
        await dispatch(filterNotesAsync({
            apiToken: apiToken,
            filter: filter,
            activePage: 1,
            pageSize: pageSizeRef.current
        }));
    }

    const requestApiAccessToken = async (): Promise<string> => {
        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        }
    };

    const onPageSizeChange = (value: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const parsedValue = parseInt(value.target.value);
        if (isNaN(parsedValue) || parsedValue < 0) {
            setPageSize(0);
            return;
        }
        if (parseInt(value.target.value) > getMaxPageSize()) {
            setPageSize(getMaxPageSize());
            return;
        }
        setPageSize(parseInt(value.target.value));
    }

    const onApplyPageSizeChange = async () => {
        setActivePage(1);
        return filterQuery === undefined
            ? getNotes()
            : handleFilterNotes(filterQuery);
    }

    return (
        <Row>
            <Accordion className={styles.accorditionPaddingBottom}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Filters</Accordion.Header>
                    <Accordion.Body>
                        <Filters
                            filterNotesHandler={handleFilterNotes}/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Col className={styles.addNotesButton}>
                <Button variant="primary" onClick={() => navigate('add-note')}>
                    Add
                </Button>
            </Col>
            <Col xs={12} className="mb-2">
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Subject</th>
                        <th>Archived</th>
                        <th>Created</th>
                        <th>Modified</th>
                    </tr>
                    </thead>
                    <tbody>
                    {notes.map((note, index) =>
                        <NoteListRow key={note.id} note={note}
                                     rowIndex={activePageRef.current === 1 ? ++index : activePageRef.current * tempPageSize - tempPageSize + ++index}/>
                    )}
                    </tbody>
                </Table>
            </Col>
            <Col className="col-12 mb-2">
                <YaPagination 
                    activePage={activePage}
                    showNumberOfPagesMax={showNumberOfPagesMax}
                    changePage={changePage} 
                    itemsTotal={totalNotes}
                    pageSize={tempPageSize}
                />
            </Col>
            <Col className="col-12 mb-2">
                <YaPaginationSize
                    updatePageSize={updatePageSize}
                    pageSize={pageSizeRef.current}
                    changePage={onPageSizeChange}
                    applyPageSizeChange={onApplyPageSizeChange}
                    maxPageSize={getMaxPageSize()}/>
            </Col>
        </Row>
    );
};

export default connect()(Notes);
